import React from "react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import Spinner from "@components/Spinner";

interface RequireGuestProps {
  children: ReactNode;
}

const RequireGuest: React.FC<RequireGuestProps> = ({ children }) => {
  const { status: isLoggedIn } = useAuth();

  if (isLoggedIn === undefined) {
    return (
      <div className="flex items-center justify-center fixed inset-0 z-50 bg-primary-10">
        <Spinner size="lg" />
      </div>
    );
  }

  return !isLoggedIn ? <>{children}</> : <Navigate to="/demo-lab" replace />;
};

export default RequireGuest;